module.exports = __webpack_public_path__ + "assets/img/logo4.188a5633.png";